import ReactValidator from "legacy/ReactValidator.es6"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

// Note: jQuery ($) is loaded globally

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: props.email,
      validationMessage: null,
      successMessage: null,
      processing: false,
    }
    this.validator = new ReactValidator(["email"])
    this.handleInputChange = this.handleInputChange.bind(this)
    this.submit = this.submit.bind(this)
    this.postToForgotPassword = this.postToForgotPassword.bind(this)
  }

  handleInputChange(event) {
    const name = event.target.name
    const val = event.target.value
    this.setState({ [name]: val })
  }

  submit() {
    this.validator.displayErrors()
    this.setState({ validInputs: this.validator.allValid() })
    if (
      this.validator.allValid() === true &&
      (!this.state.forgotPasswordAt || this.state.forgotPasswordAt < moment())
    ) {
      this.setState({ processing: true })
      this.setState({ validationMessage: "" })
      this.postToForgotPassword()
    }
  }

  postToForgotPassword() {
    $.post(
      "/users/password",
      { "user[email]": this.state.email.trim() },
      (data) => {
        this.setState({
          successMessage:
            "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes. We also suggest checking your spam folder.",
          processing: false,
          forgotPasswordAt: moment().add(5, "minutes"),
        })
      },
      "json"
    ).fail((data) => {
      this.setState({
        validationMessage: "Email not found, try another email or sign up.",
        processing: false,
        forgotPasswordAt: null,
      })
    })
  }

  render() {
    return (
      <div>
        <div className="clearfix">
          <h4 className="bs-mt-0 bs-mb-4 b float-left">Forgot Password</h4>
          <div
            className="forgot-password-btn text-muted float-right"
            onClick={this.props.setLoginPage}
          >
            &lt; back
          </div>
        </div>
        <div className="form-group">
          <label>Email</label>
          <div className="form-control-with-icon">
            <i className="icon icon-mail form-control-icon-left" />
            <input
              className="form-control"
              name="email"
              value={this.state.email}
              onChange={this.handleInputChange}
            />
            {this.validator.message(
              "email",
              this.state.email,
              "required|email"
            )}
            {this.validator.customMessage(this.state.validationMessage)}
            {this.state.successMessage && (
              <p className="mt-2 font-bold text-teal-700">
                {this.state.successMessage}
              </p>
            )}
          </div>
        </div>
        <NextButton
          processing={this.state.processing}
          click={this.submit}
          icon="bs-mr-3"
          text="Send Password Reset"
          processingText="Emailing Instructions..."
          btnClass="btn-primary"
        />
      </div>
    )
  }
}

ForgotPassword.propTypes = {
  email: PropTypes.string,
  setLoginPage: PropTypes.func.isRequired,
}

ForgotPassword.defaultProps = {
  email: "",
}

export default ForgotPassword
